import React, { Component } from 'react';

class Imagelist extends Component {
    componentDidMount() {
        this.imageNodes = document.getElementsByClassName('click-img');
        this.index = 0;
        this.direction = 1;
    }

    handleClick(e) {
        const iframe = document.getElementsByTagName("iframe")[0];
        // only change image when the click is not on a target with an iframe (e.g. google maps)
        if (!e.target.contains(iframe) || e.target.className === "click-img-list") {
            if (iframe) {
                iframe.className = "disable-mouse";
            }
            if (this.index > this.imageNodes.length - 2) {
                this.direction = -1;
                // so the last image will still be shown
                this.index = this.imageNodes.length - 2;
            }
            if (this.index < 0) {
                this.direction = 1;
                this.index = 0;
            }
            if (this.direction === 1 && this.imageNodes.length > 1) {
                this.imageNodes[this.index].style.visibility = "hidden";
                this.index++;
            } else {
                this.imageNodes[this.index].style.visibility = "visible";
                this.index--;
            }
        } else {
            if (iframe) {
                iframe.className = "";
            }
        }
    }

    render() {
        const imageList = this.props.list.map((o, i) => {
            if (o.indexOf("google") > -1) {
                return <div className="click-img" key={i} style={{width: "420px", height: "420px"}}>
                  <iframe className="disable-mouse" width="420" height="420" style={{border:0}} src={o} allowFullScreen></iframe>
                </div>
            } else {
                return <img className="click-img" src={o} key={i} alt=""/>;
            }
        })

        return (
            <div className="click-img-list" onClick={this.handleClick.bind(this)}>
              {imageList}
            </div>
        );
    }
}

export default Imagelist;



// WEBPACK FOOTER //
// ./src/components/other/Imagelist.js